import Navbar from './Navbar';
import Footer from './Footer';

export default function MarketingLayout({ children }) {
  return (
    <main className="marketing-layout min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-1">{children}</div>
      <Footer />
    </main>
  );
}
